import { identity } from '../brand';

/** Horizontal profile card: avatar left, identity right (like a social header). */
export function SocialCard() {
  return (
    <header className="card">
      <img
        className="card__avatar"
        src={identity.avatar}
        width={96}
        height={96}
        alt="DJ Longbeard — a wizard at the decks"
        fetchPriority="high"
      />
      <div className="card__body">
        <h1 className="card__name">{identity.name}</h1>
        <span className="card__handle">{identity.handle}</span>
        <p className="card__quote">&ldquo;{identity.quote}&rdquo;</p>
      </div>
    </header>
  );
}
